import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

// The badge uses text-surface, not text-on-dark-primary: surface flips with the theme
// like brand does, so the pair stays inverted in both.
function StepRow({ number, i18nKey }) {
  return (
    <div className="flex items-start gap-3">
      <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary font-sans text-xs font-bold text-surface">
        {number}
      </span>
      <span className="font-sans text-[13px] leading-[1.45] text-secondary">
        <Trans i18nKey={i18nKey} components={{ strong: <strong className="font-semibold text-primary" /> }} />
      </span>
    </div>
  );
}

StepRow.propTypes = {
  number: PropTypes.number.isRequired,
  i18nKey: PropTypes.string.isRequired,
};

export default function TotpSetupSteps({
  step1Key = 'heimdal_app.TOTP.setup_step_1',
  step2Key = 'heimdal_app.TOTP.setup_step_2',
  className = '',
}) {
  return (
    <div className={`flex flex-col gap-3 ${className}`.trim()}>
      <StepRow number={1} i18nKey={step1Key} />
      <StepRow number={2} i18nKey={step2Key} />
    </div>
  );
}

TotpSetupSteps.propTypes = {
  step1Key: PropTypes.string,
  step2Key: PropTypes.string,
  className: PropTypes.string,
};
